<template>
  <div>
    <div class="ti d-flex">
      <div class="d-flex-left">
        <erp-tree @node-click="nodeClick"></erp-tree>
      </div>
      <div class="d-flex-right" style="margin-top: 10px;">
        <el-button type="primary" size="mini" @click="change.visible = true">调整房产</el-button>

        <div style="width: 99%;">
          <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item label="项目">
              {{ select.house_name }}
            </el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-radio-group v-model="select.setting_type">
                <el-radio :label="1">生效中</el-radio>
                <el-radio :label="2">未生效</el-radio>
                <el-radio :label="3">已过期</el-radio>
                <el-radio :label="4">审批中</el-radio>
              </el-radio-group>
            </el-descriptions-item>
            <el-descriptions-item label="项目缴费方式">
              <span v-if="select.project_pay_type == 1">月缴</span>
              <span v-if="select.project_pay_type == 2">季缴</span>
              <span v-if="select.project_pay_type == 3">半年缴</span>
              <span v-if="select.project_pay_type == 4">年缴</span>
            </el-descriptions-item>
            <el-descriptions-item label="长期有效">
              <el-select v-model="select.is_long_time" placeholder="请选择" clearable>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="操作">
              <el-button type="default" size="mini" @click="search">查询</el-button>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div style="margin-top: 10px;">
          <el-table :data="lists">
            <el-table-column label="ID" prop="id" width="90"></el-table-column>
            <el-table-column label="名称" prop="house_name"></el-table-column>
            <el-table-column label="调整缴费方式" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.pay_type == '1'">月缴</span>
                <span v-if="scope.row.pay_type == '2'">季缴</span>
                <span v-if="scope.row.pay_type == '3'">半年缴</span>
                <span v-if="scope.row.pay_type == '4'">年缴</span>
              </template>
            </el-table-column>
            <el-table-column label="解绑费项">
              <template slot-scope="scope">
                <el-tag v-for="item in scope.row.not_chargeitem_name" :key="item">{{ item }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="有效期">
              <template slot-scope="scope">
                <span v-if="scope.row.is_long_time == 1">
                  长期有效
                </span>
                <span v-else>
                  {{ scope.row.start_date }} - {{ scope.row.end_date }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">审核中</span>
                <span v-if="scope.row.status == 2">已通过</span>
                <span v-if="scope.row.status == 0">未提交</span>
                <span v-if="scope.row.status == -1">不通过</span>
              </template>
            </el-table-column>

          </el-table>
          <el-pagination style="margin-top:12px;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagination.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="调整房产" :visible="change.visible" @close="change.visible = false">
      <el-form ref="changeForm">
        <el-form-item label="选择房产">
          <el-button @click="house.visible = true">选择房产</el-button>
        </el-form-item>
        <el-form-item label="缴费方式">
          <el-select v-model="change.pay_type">
            <el-option label="月缴" :value="1"></el-option>
            <el-option label="季缴" :value="2"></el-option>
            <el-option label="半年缴" :value="3"></el-option>
            <el-option label="年缴" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可解绑项（只需要勾选要解绑的费项，例如代收电费、代收水费）">
          <el-select v-model="change.not_chargeitem_id" style="width: 100%;" multiple clearable filterable placeholder="可跳收项目">
            <el-option
              v-for="item in chargeitem_list"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="长期有效">
          <el-switch v-model="change.is_long_time" active-value="1" inactive-value="0" @change="toggleLongTime"></el-switch>
        </el-form-item>
        <el-form-item label="有效期" v-if="!change.is_long_time || change.is_long_time === '0'">
          <el-date-picker
            v-model="change.start_time"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 145px;">
          </el-date-picker> - <el-date-picker
            v-model="change.end_time"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 145px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="已选房产">
          <el-table :data="change.data">
            <el-table-column label="ID" prop="id" width="90"></el-table-column>
            <el-table-column label="名称" prop="house_name"></el-table-column>
            <el-table-column label="类型" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.type == 'room'">单个房产</span>
                <span v-else>下属所有房产</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="removeHouseChange(scope.row.id)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="change.remark" type="textarea" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="sendHouseChange">提交</el-button>
          <el-button type="default" size="mini" @click="change.visible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="选择房产" :visible="house.visible" @close="house.visible = false">
      <div class="d-flex">
        <erp-tree @node-click="handleChoseHouse" class="d-flex-left"></erp-tree>
        <div class="d-flex-right">
          <div>
            <span>当前选择 ：{{ house.chose.house_name }}</span>
            <el-button size="mini" style="margin-left:50px;" @click="sendHouseChose">添加</el-button>
          </div>
          <div>
            <span>已选</span>
            <el-table :data="house.data">
              <el-table-column label="ID" prop="id" width="90"></el-table-column>
              <el-table-column label="名称" prop="house_name"></el-table-column>
              <el-table-column label="类型" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.type == 'room'">单个房产</span>
                  <span v-else>下属所有房产</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="danger" size="mini" @click="removeHouseChose(scope.row.id)">移除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-top:12px">
            <el-button type="primary" size="mini" @click="finishChose">确定</el-button>
            <el-button type="default" size="mini" @click="cancelChose">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'OrderPayTime',
  provide(){
    return{
      __ORDER__:null
    }
  },
  data () {
    return {
      select:{
        setting_type : 1,
        project_pay_type : '',
        house_id : 0 ,
        order_type_list : [] ,
        house_name : '',
        pindex_id : 0,
        trade_status : '',
      },
      change : {
        visible : false,
        data : [],
        start_time : '',
        end_time : '',
        pay_type : '',
        not_chargeitem_id : [],
        remark : '',
      },
      chargeitem_list : [],
      house : {
        visible : false,
        chose : {
          house_id : 0,
          house_name : '',
          pindex_id : 0 ,
          type : '',
          project_pay_type : '',
        },
        data : []
      },
      lists : [],
      pagination : {
        page : 1 ,
        limit : 10 ,
        total : 0,
      }
    }
  },
  //界面没出来前加载
  created() {
    this.search();
    this.loadChargeItems();
  },
  // 加载数据
  mounted(){
    this.__ORDER__=this;
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //点击树
    nodeClick(data){
      if(data.tree.length > 0){
        // 最后一个元素
        let treeData = data.tree[data.tree.length - 1];
        if(treeData.type === 'project') {
          this.select.pindex_id = treeData.pindex_id;
          this.select.house_id = 0;
          this.select.house_name = treeData.name;
          this.select.project_pay_type = treeData.dataObj.class2;
        }
      }
    },
    search(){
      let params = {
        page : this.pagination.page,
        limit : this.pagination.limit,
        setting_type : this.select.setting_type,
        pindex_id : this.select.pindex_id,
        is_long_time : this.select.is_long_time,
      };
      this.$myhttp.post('admin/orderPayTypeList',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code == 200){
          this.lists = backdata.data.data.list;
          this.pagination.total = backdata.data.data.count;
        }else{
          this.$Message.error(backdata.data.msg);
        }
      })
    },
    // 发起调整
    removeHouseChange(id){
      this.change.data = this.change.data.filter(item => item.id != id);
    },
    sendHouseChange(){
      let params = {
        house_list : this.change.data ,
        pay_type : this.change.pay_type,
        start_time : this.change.start_time,
        end_time : this.change.end_time,
        not_chargeitem_id : this.change.not_chargeitem_id,
        is_long_time : this.change.is_long_time ,
        remark : this.change.remark
      }
      this.$myhttp.post('admin/orderPayTypeSave',params,{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{
        if(backdata.data.code == 200){
          let batchNo = backdata.data.data.batch_no;
          // 跳转流程
          const timestamp = Date.parse(new Date());
          let url = "/#/flow/FlowView?sheet_id=292&master_id=235&timeValue=1763692730311&timeValue="+timestamp+"&batch_no="+batchNo;
          window.open(url, '_blank');
          this.change.visible = false;
        }else{
          this.$Message.error(backdata.data.msg);
        }
      })
    },
    // 选择房产
    handleChoseHouse(data){
      // 最后一个元素
      let treeData = data.tree[data.tree.length - 1];
      if(treeData.type === 'project') {
        this.house.chose.pindex_id = treeData.pindex_id;
        this.house.chose.house_id = 0;
        this.house.chose.house_name = treeData.name;
        this.house.chose.project_pay_type = treeData.dataObj.class2;
      }else{
        this.house.chose.house_id = treeData.house_id ;
        this.house.chose.house_name = treeData.ancestor_name;
        this.house.chose.type = treeData.type;
        this.house.chose.pindex_id = data.tree[0].id;
      }
    },
    sendHouseChose(){
      if(this.house.chose.house_id == 0){
        this.$message.error('不能选择整个项目');
        return;
      }

      this.house.data.push({
        id : this.house.chose.house_id,
        house_name : this.house.chose.house_name ,
        type : this.house.chose.type,
        pindex_id: this.house.chose.pindex_id,
      });
    },
    removeHouseChose(id){
      this.house.data = this.house.data.filter(item => item.id != id);
    },
    finishChose(){
      this.house.data.forEach(item => {
        this.change.data.push(item)
      })
      this.house.data = [];
      this.house.visible = false;
    },
    cancelChose(){
      this.house.data = [];
      this.house.visible = false;
    },
    handleSizeChange(val){
      this.pagination.limit = val;
      this.search();
    },
    handleCurrentChange(val){
      this.pagination.page = val;
      this.search();
    },
    loadChargeItems() {
      // 获取收费项目列表
      this.$myhttp.post('admin/common/chargritem', {} , {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata => {
        if (backdata.data.code == 200) {
          this.chargeitem_list = backdata.data.data;
        } else {
          this.$Message.error(backdata.data.msg);
        }
      });
    },
  },
  watch:{

  },
  components: {
    "erp-tree": () => import('@/components/Admin/Common/erp-tree.vue'),
  },

}
</script>

<style>
.d-flex {
  display: flex;
}
.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  width: 250px;

}
.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
.text2{
  color: rgb(250, 248, 248);
}
</style>

<style lang="scss" scoped>
.right-main {
  display: flex;
  // overflow: auto;//体内容的滚动条
  flex: 1;
  background: #fff;
}
.content{
  .header{

  }
  .header-where{
    margin-top: 5px;
  }
  .body{
    margin-top: 10px;

    .pagination-wrap{
      display: table;
      /* text-align: center; */
      margin: 20px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/orderPayType.vue